export default "__VITE_ASSET__0Juf1Z2z__"